import React from 'react';
import StorageCard from '../components/StorageCard';
import {DashboardData} from '../../../../data/models/Workspace/Dashboard';
import '../../settingsCards.css';
import styles from './StorageSettingsUI.module.css';

interface Props {
  dashboard?: DashboardData;
  onBuyAddons: () => void;
  disabled: boolean;
}

const StorageSettingsUI = React.memo(
  ({dashboard, onBuyAddons, disabled}: Props) => (
    <div className={`SettingsCards ${styles.container}`}>
      <div className="CardsRow">
        <StorageCard
          onBuyAddons={onBuyAddons}
          storageAvailable={dashboard?.maxStorageSpaceAvailable ?? 0}
          storageUsed={dashboard?.storageSpaceUsed ?? 0}
          disabled={disabled}
        />
      </div>
    </div>
  ),
);

export default StorageSettingsUI;
